<template>
  <v-layout row wrap>
    <vue-title :title="$t('server.title')" />
    <v-container>
      <v-row>
        <v-col cols="12" md="9">
          <v-card>
            <v-card-title primary-title><h3 class="headline mb-0">{{ $t("server.requests") }}</h3></v-card-title>
            <v-card-text class="v-card__text">
              <div class="text-xs-center">
                <v-pagination
                  v-model="day"
                  :length="7"
                ></v-pagination>
              </div>
              <RequestsChart :requests="requests" :day="day" />
              <ResponseTimeChart :requests="requests" :day="day" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card class="mb-3">
            <v-card-title primary-title><h3 class="headline mb-0">{{ $t("server.emailFilter") }}</h3></v-card-title>
            <v-card-text class="v-card__text">
              <v-checkbox hide-details v-model="emailFilter.participation" label="Participation" />
              <v-checkbox hide-details v-model="emailFilter.applicationConfirmation" label="ApplicationConfirmation" />
              <v-checkbox hide-details v-model="emailFilter.emailConfirmation" label="EmailConfirmation" />
              <v-checkbox hide-details v-model="emailFilter.resetPassword" label="ResetPassword" />
              <v-checkbox hide-details v-model="emailFilter.paymentConfirmation" label="PaymentConfirmation" />
            </v-card-text>
            <v-card-actions>
              <v-btn @click="saveEmail" color="success">{{$t("ctrl.save")}}</v-btn>
            </v-card-actions>
            <v-snackbar
              v-model="snackbar"
              :bottom="true"
              :timeout="5000">
              {{ $t('ctrl.successfullySaved') }}
              <v-btn
                color="red"
                @click="snackbar = false">
                {{ $t('ctrl.close') }}
              </v-btn>
            </v-snackbar>
          </v-card>
          <v-card class="mb-3">
            <v-card-title primary-title><h3 class="headline mb-0">{{ $t("server.clients") }}</h3></v-card-title>
            <v-card-text class="v-card__text">
              <h1>{{this.clients}}</h1>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row  no-gutters>
        <v-col  no-gutters>
          <v-card>
            <v-card-title primary-title><h3 class="headline mb-0">{{ $t("server.logs") }}</h3></v-card-title>
            <v-card-text class="v-card__text">
              <v-data-table
                  :items="this.logs"
                  hide-default-headers
                  :headers="requestsHeaders"
                  hide-default-footer
                  class="elevation-0"
                  disable-pagination
                >
                  <template v-slot:item.level="{item}">
                    <v-icon v-if="item.level == 0">bug_report</v-icon>
                      <v-icon v-else-if="item.level == 1">code</v-icon>
                      <v-icon v-else-if="item.level == 2" color="blue">info</v-icon>
                      <v-icon v-else-if="item.level == 3" color="yellow">warning</v-icon>
                      <v-icon v-else-if="item.level == 4" color="orange">error</v-icon>
                      <v-icon v-else color="red">priority_high</v-icon>
                  </template>
                  <template v-slot:item.timestamp="{item}">
                    {{ item.timestamp | fulltimestamp }}
                  </template>
                </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-flex xs12 md5>
    <v-layout column>
    <v-flex ma-2>
      
      
    </v-flex>
    <v-flex ma-2>
      
    </v-flex>
    </v-layout>
    </v-flex>
    <v-flex xs12 md7>
    <v-layout column>
      <v-flex ma-2>
        
      </v-flex>
    </v-layout>
    </v-flex>
    </v-layout>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VCard,
    VCardText,
    VCardTitle,
    VPagination,
    VCheckbox,
    VSnackbar
  } from 'vuetify/lib'
  import RequestsChart from '../charts/RequestsChart.vue'
  import ResponseTimeChart from '../charts/ResponseTimeChart.vue'
  import fccapi from '../fccapi.js'

  export default {
    name: 'Applications',
    data: () => ({
      requests: [],
      logs: [],
      headers: [
          { text: 'Time', align: 'left' },
          { text: 'RPM', value: 'requestsPerMinute', align: 'right' },
          { text: 'Response time', value: 'averageResponseTime', align: 'right' },
        ],
      day: 0,
      items: [],
      emailFilter: {},
      snackbar: false,
      clients: null
    }),
    props: {
      source: String
    },
    components: {
      VDataTable,
      VCard,
      VCardText,
      VCardTitle,
      VPagination,
      RequestsChart,
      ResponseTimeChart,
      VCheckbox,
      VSnackbar
    },
    computed: {
      requestsHeaders: function () {
        return [
          { text: '', value: 'level' },
          { text: '', value: 'timestamp' },
          { text: '', value: 'messageTemplate.text' }
        ];
      },
    },
    mounted() {
      fccapi.get('statistics/logs').then((r) => {
          this.logs = Object.keys(r.data).map(function(key) {
              return r.data[key];
          });
          console.log(r);
      })
      fccapi.get('statistics/requests').then((r) => {
          this.requests = r.data;
      })
      fccapi.get('emails/filter').then((r) => {
          this.emailFilter = r.data;
      })
      fccapi.get('statistics/clients').then((r) => {
        this.clients = r.data;
      })
      
    },
    methods:{
      saveEmail: function(){
          fccapi.post('emails/filter', this.emailFilter).then((r) => {
              this.emailFilter = r.data;
              this.snackbar = true;
          })
      }
    },
    filters: {
      ms: function(value) {
        return Math.floor(parseFloat(value))+" ms";
      },
      timestamp: function(value) {
        var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
        var r = value.match(re);
        return parseInt(r[4])+":"+parseInt(r[5]);
      },
      fulltimestamp: function(value) {
        var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
        var r = value.match(re);
        return r[0].replace('T', ' ');
      }
    },
  }
</script>